<div class="rounded-card-light" [ngClass]="{ 'selected': selected()}">
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-align-items-center ion-justify-content-center ion-padding">
      <ion-col size="1" class="min-width-icon">
        <ion-icon name="person-circle" class="big" [color]="selected() ? 'primary' : 'secondary'" />
      </ion-col>
      <ion-col>
      @if (payee && !composer) {
        <div [innerHTML]="payee._highlightResult?.companyName?.value || payee.companyName"></div>
      }
    @if (composer) {
      <div [innerHTML]="composer.companyName"></div>
    }
    @if (artist) {
      <div [innerHTML]="artist._highlightResult?.name?.value || artist.name"></div>
    }
  </ion-col>
  <ion-col class="ion-text-center min-width ion-text-end" size="6">
    @if (artist) {
      <ion-row>
        <ion-col class="ion-text-end">
          @if ((version() === 'full' || version() === 'admin') && artist.lastInvoiceStatus) {
            <ion-chip
              [color]="artistService.getColorByStatus(artist.lastInvoiceStatus)"
              class="float-chip"
            >{{ artistService.getTranslatedStatus(artist.lastInvoiceStatus) }}</ion-chip>
          }
        @if (showChangeArtist()) {
          <ion-button
            color="secondary"
            class="change-artist-button"
          >Trocar artista</ion-button>
        }
      </ion-col>
    </ion-row>
  }

  @if (payee && !isChildPayeeDisplay()) {
    <ion-row>
      <ion-col class="ion-text-end">
        @if ((version() === 'full' || version() === 'admin') && payee.internalProperties?.lastInvoiceStatus) {
          <ion-chip
            [color]="artistService.getColorByStatus(payee.internalProperties?.lastInvoiceStatus)"
            class="float-chip"
          >{{ artistService.getTranslatedStatus(payee.internalProperties?.lastInvoiceStatus) }}</ion-chip>
        }
      @if (showChangeArtist()) {
        <ion-button
          color="secondary"
          class="change-artist-button"
        >Trocar compositor</ion-button>
      }
    </ion-col>
  </ion-row>
}

<ion-row>
  <ion-col class="ion-text-end ion-padding-end">
    @if (payee && !isChildPayeeDisplay()) {
      <ion-note class="value-note">
        @if (version() !== 'simple') {
          {{ (totalPublishingBalance) | currency:'BRL' }}
        }
        @if (version() === 'simple') {
          @if (composer) {
            @if (composer.id !== payee?.id) {
              {{ (composer.totalStatementSum || 0) | currency:'BRL' }}
            }
            @else {
              {{ (payee?.internalProperties?.internalPublishingSumIndividual || 0) | currency:'BRL' }}
            }
          }
        }
      </ion-note>
    }
    @if (artist) {
      <ion-note>
        {{ (artist?.totalStatementsSumIndividual || 0) | currency:'BRL' }}
      </ion-note>
    }
  </ion-col>
</ion-row>
</ion-col>
</ion-row>

@if (version() === 'admin') {
  @if (payee) {
    <ion-row
      class="table-items ion-align-items-center"
      >
      @if (payee.internalProperties?.composers?.length > 0) {
        <ion-col size="12" class="expandable-column">
          <ion-accordion-group (click)="preventBubble($event)">
            <ion-accordion value="composers">
              <ion-item slot="header" color="light" class="composer-item">
                <ion-note>Compositores: {{ payee.internalProperties.composers.length }}</ion-note>
                <ion-icon name="chevron-down" class="ion-accordion-toggle-icon" slot="start" />
              </ion-item>
              <div slot="content">
                <ion-item color="light">
                  <ion-note>
                    @for (composer of composers; track (composer.id || composer.objectID || (composer.companyName?.value || composer.companyName)); let last = $last) {
                      <span [innerHTML]="composer.companyName?.value || composer.companyName"></span>
                      @if (!last) {
                        <span>, </span>
                      }
                    }
                  </ion-note>
                </ion-item>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-col>
      }
      @if (payee.internalProperties?.composers?.length > 0) {
        <ion-col size="12" class="ion-hide" />
      }
      <ion-col size="12" class="expandable-column">
        @if (isIndividualBeneficiary && !isChildPayeeDisplay()) {
          <ion-label>
            <p class="ion-padding-start">Beneficiário individual</p>
          </ion-label>
        }
        @if (hasLinkedPayees && !isChildPayeeDisplay()) {
          <ion-label>
            <p class="ion-padding-start">Principal, com {{ payee.internalProperties?.linkedPayees?.length }} vinculado(s)</p>
          </ion-label>
        }
        @if ((isChildPayee && !isChildPayeeDisplay()) || isChildPayeeDisplay()) {
          <ion-label>
            <p class="ion-padding-start">
              @if (isChildPayeeDisplay()) {
                <ion-icon name="return-down-forward-outline" class="child-indicator" />
              }
              Beneficiário vinculado a:
              @if (parentPayee$ | async; as parentPayee) {
                <span class="linked-payee-name" (click)="onLinkedPayeeClick(parentPayee.id, $event)">
                  <span [innerHTML]="parentPayee?._highlightResult?.companyName?.value || parentPayee?.companyName"></span>
                </span>
              } @else {
                <span>Carregando...</span>
              }
            </p>
          </ion-label>
        }
      </ion-col>
      @if (!isChildPayeeDisplay()) {
        <ion-col size="6">
          <ion-label>
            <p class="padding-column">
              BPA:
              @if (payee.internalProperties?.blocked) {
                <ion-chip color="dark" class="ion-margin-start">
                  <ion-icon name="ban-outline" color="dark" />
                  <ion-label>Bloqueado</ion-label>
                </ion-chip>
              }
              @if (!payee.internalProperties?.blocked && payee.internalProperties?.lastSignIn) {
                <ion-chip color="success" class="ion-margin-start">
                  <ion-icon name="checkmark-circle-outline" color="success" />
                  <ion-label>Ativo</ion-label>
                </ion-chip>
              }
              @if (!payee.internalProperties?.blocked && !payee.internalProperties?.lastSignIn && payee.internalProperties?.invitedAt) {
                <ion-chip color="warning" class="ion-margin-start">
                  <ion-icon name="time-outline" color="warning" />
                  <ion-label>Convidado</ion-label>
                </ion-chip>
              }
              @if (!payee.internalProperties?.blocked && !payee.internalProperties?.invitedAt) {
                <ion-chip color="danger" class="ion-margin-start">
                  <ion-icon name="close-circle-outline" color="danger" />
                  <ion-label>Não convidado</ion-label>
                </ion-chip>
              }
            </p>
          </ion-label>
        </ion-col>
      }
      <ion-col [size]="!isChildPayeeDisplay() ? '6' : '12'">
        <ion-label>
          <p>Repasse Autoral: {{ payee.internalProperties?.share || 0 }}%</p>
        </ion-label>
      </ion-col>
    </ion-row>
  }
}
</ion-grid>
</div>
